import { useMemo } from "react";
import { useSelector } from "react-redux";

import { selectProfile, selectRole } from "@/redux/selectors/authSelectors";

import { checkPermissionByRole } from "../helpers/checkPermissionByRole";
import type { PermissionKey } from "../types";

/**
 * React hook to filter items based on permission keys.
 * Items without a permissionKey are always included.
 * Items with a permissionKey are checked against the current user's permissions.
 */
export function useFilterPermittedItems<T extends { permissionKey?: PermissionKey }>(
  items: T[],
): T[] {
  const role = useSelector(selectRole);
  const profile = useSelector(selectProfile);

  return useMemo(() => {
    return items.filter(({ permissionKey }) => {
      if (!permissionKey) return true;

      return checkPermissionByRole({ permissionKey, profile, role });
    });
  }, [items, profile, role]);
}
